import { Controller } from 'stimulus';

class ResponsiveVideo extends Controller {
  connect() {
    try {
      this.element.appendChild(ResponsiveVideo.videoSourceElement(this.videoSource()));
      this.element.play();
    } catch (err) {
      //
    }
  }

  static videoSourceElement(videoSource) {
    const element = document.createElement('source');
    element.type = 'video/mp4';
    element.src = videoSource;
    return element;
  }

  videoSource() {
    if (window.innerWidth >= 992) {
      return this.data.get('large-url');
    }

    if (this.data.get('small-url')) {
      return this.data.get('small-url');
    }

    return this.data.get('large-url');
  }
}

ResponsiveVideo.targets = [
  //
];

export default ResponsiveVideo;
